module.exports = __webpack_public_path__ + "assets/img/24_1071_big.daf87525.jpg";